/**
 * Email confirmation (public). Confirms only when the person presses the button: mail
 * scanners open links on their own, and an open must not count as a yes.
 */
import { useParams } from 'react-router-dom';
import { useMutation } from '@tanstack/react-query';
import { CheckCircle2, Mail, XCircle } from 'lucide-react';
import { confirmEmail } from '@/lib/connections';

export default function ConfirmEmailPage() {
  const { token = '' } = useParams<{ token: string }>();
  const m = useMutation({ mutationFn: () => confirmEmail(token) });
  const r = m.data;
  return (
    <div className="min-h-screen bg-bg text-muted-strong flex items-center justify-center px-4">
      <div className="max-w-sm w-full rounded-2xl border border-slate-800 bg-bg-card p-6 text-center">
        <div className="text-[11px] tracking-[0.2em] uppercase text-muted mb-4">KAF PRO</div>
        {!r && (
          <>
            <Mail size={28} className="mx-auto text-accent-400 mb-3" />
            <h1 className="text-lg font-medium mb-2">Confirm your email</h1>
            <p className="text-sm text-muted mb-5">So KAF PRO can send you scripts, call links and updates here.</p>
            <button onClick={() => m.mutate()} disabled={m.isPending} data-testid="confirm-email-yes"
              className="w-full rounded-xl bg-accent-600 hover:bg-accent-500 text-white py-3 font-medium disabled:opacity-50">
              {m.isPending ? 'Confirming...' : 'Yes, this is my email'}
            </button>
            {m.isError && <p className="mt-3 text-sm text-red-300">That did not go through. Try again.</p>}
          </>
        )}
        {r && (
          <div data-testid="confirm-email-result">
            {r.ok ? <CheckCircle2 size={28} className="mx-auto text-emerald-300 mb-3" /> : <XCircle size={28} className="mx-auto text-red-300 mb-3" />}
            <p className="text-sm">{r.message}</p>
          </div>
        )}
      </div>
    </div>
  );
}
